/* istanbul ignore file */

export { LogoGallery as default } from "./LogoGallery";
